import { useRouter } from 'next/router';
import { ReactElement } from 'react';
import { IsLoginChecker } from '../../../common/checkers/IsLoginChecker';
import { TrackPageViewContainer } from '../../../common/containers/TrackPageViewContainer';
import { t } from '../../../common/getTranslations';
import { Layout } from '../../../design-system/layout/Layout';
import { CashHistoryContainer } from '../../../domain/history/cash/container/CashHistoryContainer';
import { HistoryListType } from '../../../domain/history/type';
import { CommonMobileHeaderType } from '../../../header/constants';
function CashPage() {
  const router = useRouter();
  const currentType = router.query?.tab as string ?? HistoryListType.Buy;
  return <IsLoginChecker>
      <CashHistoryContainer />
      <TrackPageViewContainer trackObj={{
      section: '더보기',
      page: `${currentType === HistoryListType.Buy ? '캐시내역_충전내역' : '캐시내역_사용내역'}`,
      actionType: 'Pageview',
      actionName: '캐시내역_화면',
      customProps: {
        user_action: 'pv'
      }
    }} />
    </IsLoginChecker>;
}
CashPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={t('cash_history_title')} mobileLayoutConfig={{
    shouldShowHeader: true,
    headerType: CommonMobileHeaderType.Cash
  }} pcLayoutConfig={{
    shouldShowHeader: true,
    shouldShowFooter: false
  }}>
      {page}
    </Layout>;
};
export default CashPage;